import { ExclusionItemGridView } from '../view/ExclusionItemGridView';
import { templateExclusionItemGrid } from '../view/template';
import { ExclusionItemGridRepository } from '../repository/ExclusionItemGridRepository';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { ExclusionItemGridWebComponent } from '..';

export class ExclusionItemGridController extends BaseWebComponentController {
  public component: ExclusionItemGridWebComponent;
  public dataRepository: ExclusionItemGridRepository;
  public view: ExclusionItemGridView;
  public viewConstructor: typeof ExclusionItemGridView;
  public dataRepositoryConstructor: typeof ExclusionItemGridRepository;

  constructor(component: ExclusionItemGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: ExclusionItemGridView,
      viewTemplate: templateExclusionItemGrid,
      dataRepositoryConstructor: ExclusionItemGridRepository,
    });
  }

  async getDataForView(): Promise<any> {
    return {};
  }
}
